'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../styleInject.js');

var css_248z = ".PackageAdditionalInfoForm-module_textarea__TjPvC{display:flex;min-height:200px;width:100%}";
var styles = {"textarea":"PackageAdditionalInfoForm-module_textarea__TjPvC"};
styleInject["default"](css_248z, 'b6232a45-aff8-46af-a6a2-8fe8523af985');

exports["default"] = styles;
